



























import { mixins } from 'vue-class-component';
import LocationPanelState from '@/mixins/LocationPanelState';

export default class LocationPanelNavItem extends mixins(LocationPanelState) {
    private openItem(): void {
        if (this.activeLocationPanelItem === this.id) {
            this.setActiveLocationPanelItem(null);
            this.setActiveMarkerCategory(null);
        } else {
            this.setActiveLocationPanelItem(this.id);
            this.isAboutItem ? this.setActiveMarkerCategory(null) : this.setActiveMarkerCategory(this.id);
        }
    }
}
